import { api } from '../middleware/api';

export const stepurchaseorderApi = api
  .enhanceEndpoints({ addTagTypes: ['Purchaseorder'] })
  .injectEndpoints({
    endpoints: builder => ({
      getPurchaseorders: builder.query<st_epurchaseorder[], string>({
        query: cid => `stepurchaseorder/${cid}`,
        providesTags: ['Purchaseorder']
      }),
      getPurchaseorderByPending: builder.query<st_epurchaseorder[], string>({
        query: cid => `stepurchaseorder/bypend/${cid}`,
        providesTags: ['Purchaseorder']
      }),
      getPurchaseorder: builder.query<st_epurchaseorder, string>({
        query: id => `stepurchaseorder/byid/${id}`
      }),
      insertPurchaseorder: builder.mutation({
        query: gate => ({
          url: `stepurchaseorder/`,
          method: 'POST',
          body: gate
        }),
        invalidatesTags: ['Purchaseorder']
      }),
      updatePurchaseorder: builder.mutation({
        query: gate => ({
          url: `stepurchaseorder/`,
          method: 'PUT',
          body: gate
        }),
        invalidatesTags: ['Purchaseorder']
      }),
      deletePurchaseorder: builder.mutation({
        query: purchaseorder => ({
          url: `stepurchaseorder/${purchaseorder.po_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Purchaseorder']
      })
    })
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPurchaseordersQuery,
  useGetPurchaseorderByPendingQuery,
  useGetPurchaseorderQuery,
  useLazyGetPurchaseorderQuery,
  useInsertPurchaseorderMutation,
  useUpdatePurchaseorderMutation,
  useDeletePurchaseorderMutation
} = stepurchaseorderApi;

